import { render, staticRenderFns } from "./SchoolListPagination.vue?vue&type=template&id=2e55290e"
import script from "./SchoolListPagination.vue?vue&type=script&lang=js"
export * from "./SchoolListPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports